import ZJApp from "../../../../app";

let utils = ZJApp.ZJUtils;
let ZJApi = ZJApp.ZJApis.ZJApi;

const info = {
  service: "BusinessService",
  controller: "BusinessPayOrder",
};
const methods = [
  "GetItemByTransNo",
  "GetPageContentByConditions"
];

const factory = (Fun) => {
  utils.extend(Fun.prototype, info);
  methods.forEach((path) => {
    Fun.prototype[path] = function (data) {
      return this.post(path, data);
    };
  });
};

const BusinessQueryOrderApi = ZJApi.defineNewApi("BusinessQueryOrderApi", factory);

export default BusinessQueryOrderApi;